class QuickView extends HTMLElement {
  constructor() {
    super();
  }


  async renderAndOpen(handle) {

    try {

      const requestQuickView = await fetch(`https://${window?.Shopify?.shop}${window?.Shopify?.routes?.root}products/${handle}?section_id=product-quick-view`);

      const quickViewResponse = await requestQuickView.text();

      let p = new DOMParser();
      let doc = p.parseFromString(quickViewResponse, "text/html");
      let template = doc.querySelector(".quick-view__wrapper");

      this.innerHTML = template.outerHTML;
      this.classList.add('open');


      const closer = this.querySelector(".quick-view__closer");
      if (closer) {
        closer.addEventListener("click", () => {
          this.close();
        });
      }


    } catch (error) {
      console.error(`There was an error generating the product quick view -> ${error}`);

    }


  }

  close() {
    this.classList.remove('open');
  }




}

customElements.define("quick-view", QuickView);




class QuickViewOpen extends HTMLElement {
  constructor() {
    super();

    const handle = this.getAttribute('data-handle');

    this.addEventListener('click', (e) => {
      e.preventDefault();

      const quickView = document.querySelector('quick-view');
      if (quickView) {
        quickView.renderAndOpen(handle);
      } else {
        console.warn('No <quick-view> element found or renderAndOpen() missing.');
      }
    });
  }
}

customElements.define("quick-view-open", QuickViewOpen);
